<acm-header
    [user]="user$ | async"
    (logoutEvent)="onLogout()"
    [envDisplayName]="envDisplayName"
    [isProd]="isProd"
/>
